import apiClient from './index';

const version = 'v1';
const ecaEndpoint = (path: string) => `${version}/eca${path}`;

export const getSavedSearchesTemplateGroupsRoot = (
  clientId: string,
  params: Record<string, unknown> = {}
) => {
  return apiClient.get(
    ecaEndpoint(`/savedsearchtemplate/root/client/${clientId}`),
    {params}
  );
};

export const getTemplateGroupDetails = (clientId: string, groupId: string) => {
  return apiClient.get(
    ecaEndpoint(
      `/savedsearchtemplate/client/${clientId}/groups/${groupId}/createdbydetails`
    )
  );
};

export const getTemplateSavedSearchesChildren = (
  clientId: string,
  groupId: string
) => {
  return apiClient.get(
    ecaEndpoint(`/savedsearchtemplate/client/${clientId}/groups/${groupId}`)
  );
};

export const getTemplateSavedSearchesDetails = (
  clientId: string,
  savedSerchId: string
) => {
  return apiClient.get(
    ecaEndpoint(
      `/savedsearchtemplate/client/${clientId}/savedsearch/${savedSerchId}/summarydetails`
    )
  );
};

export const updateTemplateSavedSearchesDetails = (
  params: string,
  savedSearchId: string,
  reqBody: any
) => {
  return apiClient.put(
    ecaEndpoint(`/savedsearches/${savedSearchId}` + params),
    reqBody
  );
};

export const getTemplateSavedSearchesFilter = (
  clientId: string,
  searchTerm: string
) => {
  return apiClient.get(
    ecaEndpoint(
      `/savedsearchtemplate/client/${clientId}/savedsearchesfilter?searchTerm=${searchTerm}`
    )
  );
};

export const deleteTemplateSavedSearches = (params: string, id: string) => {
  return apiClient.delete(ecaEndpoint(`/savedsearches/${id}` + params));
};

export const deleteTemplateSavedSearchesGroup = (
  params: string,
  id: string
) => {
  return apiClient.delete(ecaEndpoint(`/groups/${id}` + params));
};

export const addNewGroup = async (
  params: string,
  reqBody: {name: string; parentGroupId: string | null}
) => {
  const result = await apiClient.post(
    ecaEndpoint(`/savedsearchtemplate/client/${params}`),
    reqBody
  );
  return result.data;
};

export const updateSavedSearchGroupTemplate = (
  groupId: string,
  requestBody: {name: string; parentGroupId: string | null}
) => {
  return apiClient.put(
    ecaEndpoint(`/savedsearchTemplate/groups/${groupId}`),
    requestBody
  );
};

export const deleteSavedSearchGroupTemplate = (groupId: string) => {
  return apiClient.delete(
    ecaEndpoint(`/savedsearchtemplate/groups/${groupId}`)
  );
};

export const addSavedSearchToTemplate = async (
  clientId: string,
  requestBody: any
) => {
  return apiClient.post(
    ecaEndpoint(`/savedsearchtemplate/client/${clientId}/template`),
    requestBody
  );
};

export const checkSavedSearchesValidation = (
  clientId: string,
  projectId: string,
  saveSearchId: string
) => {
  return apiClient.get(
    ecaEndpoint(
      `/savedsearches/validate?clientId=${clientId}&projectId=${projectId}&saveSearchId=${saveSearchId}`
    )
  );
};

export const updateSavedSearchTemplate = async (
  savedSearchId: string,
  requestBody: {name: string; groupId: string}
) => {
  return apiClient.put(
    ecaEndpoint(`/savedsearchtemplate/savedSearch/${savedSearchId}`),
    requestBody
  );
};

export const deleteSavedSearchTemplateById = async (savedSearchId: string) =>
  apiClient.delete(ecaEndpoint(`/savedsearchtemplate/savedsearch/${savedSearchId}`));
